import {useDebugValue} from 'react';

import {getNoUndefValuesArray, getUniqueValuesArray} from '../../../utils/array';

function useStoreKeys(config, defaultStore, otherStores) {
    const {
        storeKeysRef
    } = config;

    const {
        [storeKeysRef]: defaultKeys
    } = defaultStore;

    const otherKeys = getNoUndefValuesArray(otherStores.map((store) => (
        store[storeKeysRef]
    )));

    const specifiedKeys = otherKeys.reduce((accumulatedKeys, currentKeys) => ([
        ...accumulatedKeys,
        ...getNoUndefValuesArray(currentKeys)
    ]), []);

    const storeKeys = getUniqueValuesArray([
        ...defaultKeys,
        ...specifiedKeys
    ]);

    const result = {
        storeKeys
    };

    useDebugValue(result);

    return result;
}

export {useStoreKeys};
